import React from "react"
import ConfirmEmail from "pages/Unauthenticated/ConfirmEmail"
import { Redirect } from "react-router-dom"
import { loginPath } from "utilities/routes"
import { User } from "sharedTypes"

type Props = {
  currentUser: User
}

const ConfirmEmailTokenHandler = ({ currentUser }: Props) => {
  if (!currentUser.id) {
    return <Redirect to={loginPath()} />
  }

  return <ConfirmEmail currentUser={currentUser} />
}

export default ConfirmEmailTokenHandler
